import React from 'react';
import {
  BrowserRouter,
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router-dom';

import { createClient, Provider } from 'urql';

import PlayerPage from './pages/PlayerPage';

declare var API_URL: string | undefined; // injected by Cloudflare Worker

const resolvedApiUrl =
  typeof API_URL === 'string' && API_URL.length > 0
    ? API_URL
    : 'https://stage.backbon3.com/graphql';

const client = createClient({
  url: resolvedApiUrl,
});

const renderPlayerPage = ({
  match: {
    params: { id },
  },
}: RouteComponentProps<{ id: string }>) => <PlayerPage id={id} />;

function App() {
  return (
    <Provider value={client}>
      <BrowserRouter basename={'/highlights'}>
        <Switch>
          <Route exact path="/:id/:slug" render={renderPlayerPage} />
          <Route exact path="/:id" render={renderPlayerPage} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
